import {createApp} from 'vue'
import App from "@/App.vue";
import router from "./router";
import store from "@/store";
import plugins from "@/plugins/vuePlugins";


const app = createApp(App)
app.use(store)
app.use(plugins)
app.use(router)

app.mount('#app')
